<div [class.hidden]="hasCustomer()" class="pick-customer">
    <button (click)="isOpen = !isOpen" cdkOverlayOrigin #trigger="cdkOverlayOrigin" matRipple apStatus="Add a customer to this invoice" accent="" mat-raised-button><mat-icon>person_add</mat-icon> Add a customer</button>
</div>

<div *ngIf="hasCustomer()" class="customer">

    <ng-container *ngIf="customer">
        <div *ngIf="customer.name">{{customer.name}}</div>
        <div *ngIf="customer.email">{{customer.email}}</div>
        <div *ngIf="customer.phone != null"><span [apPhone]="customer.phone">{{customer.phone | phone}}</span></div>
    </ng-container>

    <button (click)="editCustomer()" mat-button>Edit</button><button (click)="chooseDifferentCustomer()" mat-button>Choose a different Customer</button>
</div>

<ng-template cdkConnectedOverlay (backdropClick)="close()" (detach)="close()"
    [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'" [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isOpen" [cdkConnectedOverlayOffsetY]="-150">
    <div class="customer-search mat-elevation-z10">
        <mat-form-field class="search" appearance="outline">
            <mat-label>Search</mat-label>
            <input placeholder="type name/phone" (keyup)="findCustomers(searchText.value)" matInput #searchText
                value="">
        </mat-form-field>

        <div>
            <div *ngFor="let customer of customers">
                <button mat-button (click)="pickCustomer(customer)">{{customer.name}}</button> -- <span [apPhone]="customer.phone">{{customer.phone | phone}}</span>
            </div>
        </div>

        <div>
            <button (click)="createCustomer()" *ngIf="!searchText.value" mat-stroked-button color="primary">Create a new
                customer</button>
            <button (click)="createCustomer(searchText.value)" *ngIf="searchText.value" mat-stroked-button
                color="primary">Create {{searchText.value}} as new customer</button>
        </div>
    </div>
</ng-template>
